import type { FC } from "react";
import { useGoalsRight } from "web_myplann/Api/Rights/RightsProvider";
import { ProfilePage } from "web_myplann/Profile/Pages/ProfilePage";
import { ProfileV2Page } from "web_myplann/Profile/Pages/ProfileV2Page";

export const ProfilePageResolver: FC = () => {
	const hasGoalsRight = useGoalsRight();

	return hasGoalsRight ? <ProfileV2Page /> : <ProfilePage />;
};
